/**
 * User Repository Interface
 * Defines contracts for user data operations
 * This is an abstract interface that will be implemented by the data layer
 */
export class UserRepository {
    /**
     * Get user profile
     * @returns {Promise<UserEntity>}
     */
    async getUserProfile() {
        throw new Error('getUserProfile must be implemented');
    }

    /**
     * Update user profile
     * @param {Object} userData - User data to update
     * @returns {Promise<UserEntity>}
     */
    async updateUserProfile(userData) {
        throw new Error('updateUserProfile must be implemented');
    }

    /**
     * Get credit balance and transaction history
     * @returns {Promise<{balance: number, transactions: TransactionEntity[]}>}
     */
    async getCreditBalance() {
        throw new Error('getCreditBalance must be implemented');
    }

    /**
     * Get points and points history
     * @returns {Promise<{points: number, transactions: TransactionEntity[]}>}
     */
    async getPoints() {
        throw new Error('getPoints must be implemented');
    }

    /**
     * Get user vouchers
     * @returns {Promise<VoucherEntity[]>}
     */
    async getVouchers() {
        throw new Error('getVouchers must be implemented');
    }

    /**
     * Get user coupons
     * @returns {Promise<CouponEntity[]>}
     */
    async getCoupons() {
        throw new Error('getCoupons must be implemented');
    }

    /**
     * Get user orders
     * @param {Object} params - Query parameters (page, limit, status)
     * @returns {Promise<{orders: OrderEntity[], total: number}>}
     */
    async getOrders(params = {}) {
        throw new Error('getOrders must be implemented');
    }

    /**
     * Get order by ID
     * @param {string} orderId - Order ID
     * @returns {Promise<OrderEntity>}
     */
    async getOrderById(orderId) {
        throw new Error('getOrderById must be implemented');
    }

    /**
     * Update user password
     * @param {string} oldPassword - Current password
     * @param {string} newPassword - New password
     * @returns {Promise<boolean>}
     */
    async updatePassword(oldPassword, newPassword) {
        throw new Error('updatePassword must be implemented');
    }

    /**
     * Upload user avatar
     * @param {File} file - Avatar file
     * @returns {Promise<string>} - Avatar URL
     */
    async uploadAvatar(file) {
        throw new Error('uploadAvatar must be implemented');
    }
}
